import { palette, spacing } from '$tablet-app/src/app/theme';
import { Button } from '@akin-home/buttons/native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { format } from 'date-fns';
import React, { FunctionComponent } from 'react';
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';
import { CalendarItem, Meal } from '../../../models';
import Checklist from '../../Checklist/Checklist';
import NotificationModalContainer from './NotificationModalContainer';

interface Props {
  item: Exclude<CalendarItem, Meal>;
  style?: StyleProp<ViewStyle>;
  onDismiss?: () => any;
  onSnooze?: () => any;
  onViewDetails?: () => any;
}

const NotificationModalView: FunctionComponent<Props> = (props) => {
  const { item } = props;

  const handleDismiss = () => {
    props?.onDismiss?.();
  };

  return (
    <View style={[styles.container, props.style]}>
      <NotificationModalContainer emoji={item.emoji} onDismiss={handleDismiss}>
        <View style={styles.headerTime}>
          <View style={styles.calendarIcon}>
            <FontAwesomeIcon icon={['fal', 'calendar-check']} />
          </View>

          <View>
            <Text style={styles.headerTimeText}>
              {item.type} - {format(item.start, 'h:mma')}
            </Text>
          </View>
        </View>

        <Text style={styles.title}>{item.title}</Text>

        {/**
         * The below is old legacy code from back when we actually had participants on events.
         * It has been removed as participants no longer exists on calendar items
         * It is left commented here incase participant data is added back to events in the future
         */}
        {/* {item.participants ? (
          <ParticipantDisplayList participants={item.participants} />
        ) : null} */}

        <Checklist checklist={item.checklist ?? []} />
      </NotificationModalContainer>

      <View style={styles.buttons}>
        {props?.onSnooze ? (
          <Button
            variant="secondary"
            textStyle={styles.buttonText}
            style={[styles.button]}
            onPress={props?.onSnooze}
          >
            Snooze
          </Button>
        ) : null}
        {props.onViewDetails ? (
          <Button
            variant="primary"
            textStyle={styles.buttonText}
            style={[styles.button]}
            onPress={props?.onViewDetails}
          >
            View Details
          </Button>
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  calendarIcon: { marginRight: spacing[1] },

  container: {
    borderColor: palette.Secondary_blue,
    borderRadius: spacing[4],
    borderWidth: 2,
    maxWidth: '95%',
    width: 464,
    flexDirection: 'column',
    padding: spacing[5],
    backgroundColor: 'white',
  },
  headerTime: { alignItems: 'center', flexDirection: 'row' },
  headerTimeText: {
    fontSize: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: spacing[3],
  },

  buttons: {
    marginTop: spacing[6],
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: spacing[4],
  },
  button: {
    flex: 1,
  },
  buttonText: {
    fontWeight: 'bold',
  },
  snoozeButton: {
    marginRight: spacing[4],
  },
  dismissButton: {
    marginLeft: spacing[4],
  },
});

export default NotificationModalView;
